import app from './app.json';
import common from './common.json';
import glossary from './glossary.json';
import form from './form.json';
import validation from './validation.json';

const translation = {
  app,
  common,
  form,
  glossary,
  validation
};

export default translation;
